import { render, staticRenderFns } from "./yao.vue?vue&type=template&id=f619bd98&scoped=true&"
import script from "./yao.vue?vue&type=script&lang=js&"
export * from "./yao.vue?vue&type=script&lang=js&"
import style0 from "./yao.vue?vue&type=style&index=0&id=f619bd98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f619bd98",
  null
  
)

export default component.exports